module.exports = __webpack_public_path__ + "img/babylon.ec1e2f48.webp";